import { render } from "./RecentChanges.vue?vue&type=template&id=07e7cad0&scoped=true"
import script from "./RecentChanges.vue?vue&type=script&lang=js"
export * from "./RecentChanges.vue?vue&type=script&lang=js"

import "./RecentChanges.vue?vue&type=style&index=0&id=07e7cad0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07e7cad0"]])

export default __exports__